export const isNode = (maybeNode: unknown): maybeNode is Node => 'nodeType' in (maybeNode as Node);
